<template>
  <div class="exam-title exam-fill-item" :class="{ 'group-text': itemsType }" :style="formatExamIndex">
    <el-image ref="fillimage" v-if="srcList && srcList.length > 0" :preview-src-list="srcList" class="elimage" />
    <el-popover
      ref="popoverfill"
      placement="right"
      trigger="hover"
      width="200"
      :disabled="!optionImg"
      :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
    >
      <el-image :src="dsf.url.getWebPath(optionImg)">
        <div slot="error" class="image-slot">
          <i class="iconfont icon-tupianjiazaishibai err-img"></i>
        </div>
      </el-image>
    </el-popover>
    <template v-for="(item, index) in htmls">
      <template v-if="item != '—I—'">
        <div v-html="item" :key="'title_' + index" @click="showImage" class="title" @mouseover="showPopver" v-popover:popoverfill></div>
      </template>
      <template v-else>
        <!-- {{ previewStatus }}?? {{ readOnly }} - {{ subjects.result }} - {{ subjects.answer }} -->
        <input
          :key="'input_' + index"
          :readonly="readOnly"
          :class="[
            'exam-fill-input',
            'exam-fill-part_input_' + subjects.examQuestionsId + '_' + index,
            previewStatus && readOnly && subjects.result && subjects.answer
              ? fillValue['text_' + index] !== subjects.newAnswer[index]
                ? 'error'
                : ''
              : '',
          ]"
          :name="index"
          type="text"
          :value="fillValue['text_' + index]"
          @input="changeVal"
          :title="fillValue['text_' + index]"
          ondrop="return false"
        />
        <span v-if="optionsScore['score_' + index]" class="sub" :key="'score_' + index">
          （{{ parseFloat(optionsScore["score_" + index].toFixed(2)) }}分）</span
        >
      </template>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfExamFill",
  mixins: [$mixins.examControl],
  ctrlCaption: "填空题",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("exam-meta-data");
      },
    },
    itemsType: {
      type: String,
      default: "",
    },
    previewStatus: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    examIndex: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      // htmls: [],
      // fillValue: {},
      srcList: [],
      optionImg: false,
    };
  },
  created() {},
  computed: {
    formatExamIndex() {
      return "left:" + (this.examIndex > 99 ? "58px" : this.examIndex > 9 ? "48px" : "42px");
      // return ""
    },
  },
  methods: {
    showPopver(e) {
      this.$nextTick(() => {
        if (e.target.nodeName.toLowerCase() === "img") {
          this.$refs.popoverfill.updatePopper(); // 用来重新计算位置
          this.optionImg = e.target.src;
          this.$refs.popoverfill.doShow();
        } else {
          this.optionImg = false;
        }
      });
    },
    showImage(e) {
      if (e.target.nodeName.toLowerCase() === "img") {
        this.srcList = [e.target.src];
        this.$nextTick(() => {
          this.$refs.fillimage.showViewer = true;
          $(".el-image-viewer__mask").click(() => {
            this.$refs.fillimage.closeViewer();
          });
        });
      }
    },
    changeVal(evt, _val) {
      let groupIndex = evt.target.name;
      evt.target.value = _val || evt.target.value;
      let _key = "text_" + groupIndex;
      let className = "exam-fill-part_input_" + this.id + "_" + groupIndex;
      this.fillValue[_key] = document.querySelector("." + className).value;

      this.$nextTick(() => {
        this.$set(this.checkValue, this.subjects.examQuestionsId, this.fillValue);
        this.handleCheck();
      });
    },
  },
  components: {},
});
</script>
